import React from 'react';

export const Input = ({ type, name, document, placeholder, updateDocument, className }) => {

    function update(e) {
      updateDocument({ [name]: e.target.value })
    }
  
    const value = document[name] || '';
  
    return (
      <input className={className} type={type} placeholder={placeholder} value={value} onChange={update} />
    )
}